<script lang="ts">
    import { Button, Col, Input, Label } from "sveltestrap";
    import { DefaultPlaceholder, Disable, DisabledResults, Enable, EnableDisable, First, HidingTheSearchBox, LimitingTheNumberOfSelections, RTLsupport, Seconddisabled, Select, Select2multiselect, Select2singleselect, Third } from "../../../../utils/Constant/Constant";
    import {optdata,textboxdata} from "../../../../Data/Forms/Widgets/Widgets"
    import Card from "../../../Core/Card.svelte";
    let select:boolean
    const handleSelect = (value:boolean) =>{
        select = value
    }
</script>
<Col md="12">
    <Card headerTitle={Select} cardHeaderprops="pb-0">
      <div slot="contentbody">
        <div class="mb-2">
          <Label class="col-form-label" for="exampleSelect">{DefaultPlaceholder}</Label>
          <Col sm="12">
            <Input type="select" class="js-example-placeholder-multiple" name="select" id="exampleSelect" placeholder="Select Your Name">
                {#each optdata as item}
                    <option>{item}</option>
                {/each}
            </Input>
          </Col>
        </div>
        <div class="mb-2">
            <Label class="col-form-label">{Select2singleselect}</Label>
            <Col sm="12">
                <Input type="select" class="js-example-placeholder-single" name="select" id="exampleSelect" value="Alabama">
                    {#each optdata as item}
                        <option >{item}</option>
                    {/each}
                </Input>
            </Col>
        </div>
        <div class="mb-2">
            <Label class="col-form-label">{Select2multiselect}</Label>
            <Col sm="12">
                <Input type="select" class="js-example-placeholder-multiple" name="select" id="exampleSelect" >
                    {#each optdata as item}
                        <option >{item}</option>
                    {/each}
                </Input>
            </Col>
        </div>
        <div class="mb-2">
            <Label class="col-form-label" for="exampleSelect1">{RTLsupport}</Label>
            <Col sm="12">
                <Input type="select" class="js-example-rtl" name="select" id="exampleSelect1" >
                    {#each optdata as item}
                        <option >{item}</option>
                    {/each}
                </Input>
            </Col>
        </div>
        <div class="mb-2">
            <Label class="col-form-label">{LimitingTheNumberOfSelections}</Label>
            <Col sm="12">
                <Input class="js-example-basic-multiple-limit" >
                    {#each optdata as item}
                        <option >{item}</option>
                    {/each}
                </Input>
            </Col>
          </div>
        <div class="mb-2">
            <Label class="col-form-label" for="exampleSelect2">{DisabledResults}</Label>
            <Col sm="12">
                <Input type="select" class="js-example-disabled-results" name="select" id="exampleSelect2" value="First">
                    <option >{First}</option>
                    <option disabled>{Seconddisabled}</option>
                    <option >{Third}</option>
                </Input>
            </Col>
        </div>
        <div>
            <Label class="col-form-label">{HidingTheSearchBox}</Label>
            <Col sm="12">
                <Input type="select" class="js-example-basic-hide-search" name="select" id="exampleSelect2" >
                    {#each textboxdata as item}
                        <option >{item}</option>
                    {/each}
                </Input>
            </Col>
          </div>
        <div>
            <Label class="col-form-label" for="exampleSelect3">{EnableDisable}</Label>
            <Col sm="10">
                <Input type="select" class="js-example-disabled" name="select" id="exampleSelect3" value="Smith" disabled={select} >
                    {#each textboxdata as item}
                        <option >{item}</option>
                    {/each}
                </Input>
            </Col>
            <div class="mt-2">
                <Button color="primary" on:click={()=>handleSelect(false)} class="js-programmatic-enable p-2 mt-2">{Enable}</Button>
                <Button color="secondary" on:click={()=>handleSelect(true)} class="js-programmatic-disable p-2 mt-2">{Disable}</Button>
            </div>
        </div>
      </div>
    </Card>
</Col>